export default {"src":"/_next/static/media/a-series-traditional.b9555fb7.svg","height":1000,"width":1000};